module.exports = __webpack_public_path__ + "static/media/Joints.6f05d4f2.ogg";